import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { report_bill_lang } from "../../language/report_bill";
import * as moment from 'moment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { thLocale } from 'ngx-bootstrap/locale';
defineLocale('engb', enGbLocale);
defineLocale('th', thLocale);
declare var url; declare var report_url;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
  TotalPrice: number;
}

class report {
  customer_id: string;
  customer_name: string;
  place_id: string;
  place_address: string;
  place_type_desc: string;
  fee_type_description: string;
  fee_type_unit: string;
  inform_price: number;
  total_price: number;
}

@Component({
  selector: 'app-report-bill',
  templateUrl: './report-bill.component.html',
  styleUrls: ['./report-bill.component.scss']
})
export class ReportBillComponent implements OnInit {
  lang = localStorage.getItem('lang') == "EN" ? "EN" : "TH";
  language: any;
  counter = 0;
  months = [
    // {value:0,name_th:'all',n},
    { value: 1, name: { TH: 'มกราคม', EN: "January" } },
    { value: 2, name: { TH: 'กุมภาพันธ์', EN: "February" } },
    { value: 3, name: { TH: 'มีนาคม', EN: "March" } },
    { value: 4, name: { TH: 'เมษายน', EN: "April" } },
    { value: 5, name: { TH: "พฤษภาคม", EN: "May" } },
    { value: 6, name: { TH: "มิถุนายน", EN: "June" } },
    { value: 7, name: { TH: "กรกฏาคม", EN: "July" } },
    { value: 8, name: { TH: "สิงหาคม", EN: "August" } },
    { value: 9, name: { TH: "กันยายน", EN: "September" } },
    { value: 10, name: { TH: "ตุลาคม", EN: "October" } },
    { value: 11, name: { TH: "พฤศจิกายน", EN: "November" } },
    { value: 12, name: { TH: "ธันวาคม", EN: "December" } }
  ];
  types = [
    { value: 1, name: { TH: 'รายวัน', EN: "Report of Daily" } },
    { value: 2, name: { TH: 'รายเดือน', EN: "Report of Month" } },
    { value: 3, name: { TH: 'รายปี', EN: "Report of Year" } },
    { value: 4, name: { TH: 'ระบุวันเริ่มต้น/สิ้นสุด', EN: "Specify start/end date" } },
    // { value: 4, name: { TH: '3 เดือนย้อน', EN: "3 months back" } },
    // { value: 5, name: { TH: '6 เดือนย้อน', EN: "6 months back" } },
  ]
  disableSelect = true;
  daysInmonth;
  days;
  type = 2;
  day = new Date().getDay() + 1;
  month = new Date().getMonth() + 1;
  year = new Date().getFullYear();
  years: any;
  count = 0;
  interval: any;
  ShowDay: boolean = true;
  ShowMonth: boolean = true;
  ShowYear: boolean = true;
  ShowTable: boolean = false;
  ShowInvoice: boolean = false;
  ShowInformation: boolean = false;
  isLoading = false;
  search_report = '';
  all_reports: any;
  inform_count = '0';
  inform_price = 0;
  inform_price_value = '';
  report = { customer_name: "", place_id: "", place_address: "", place_type_description: "", fee_type_description: "", fee_type_unit: "", request_general_id: "", customer_id: "" };
  request_general: [];
  reports_invoices: any;
  invoices: any;
  all_reports_invoice: any;
  report_invoice = { bill_id: "", user_id: "", create_datetime: "", discount: "", total_price: "", fee_description: "", payment_description: "" };
  request_general_id = '';
  submitted = false;
  date = {
    start_date: moment(`${moment().add(-1, 'year').get('year')}-10-01`).format("YYYY-MM-DD"),
    end_date: moment(`${moment().get('year')}-09-30`).format("YYYY-MM-DD")
  }
  municipality_id = '';
  token = '';
  database = '';
  dtOptions: DataTables.Settings = {};
  reports: report[];

  constructor(
    private http: HttpClient,
    private service: MyserviceService,
    private chRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private localeService: BsLocaleService,
    private router: Router,
    private modalService: BsModalService) {
    this.language = report_bill_lang[this.lang];
  }

  ngOnInit() {
    if (localStorage.getItem('year') != null) {
      this.year = parseInt(localStorage.getItem('year'));
    }

    if (parseInt(this.year.toString()) < 2500) {
      this.year = this.year + 543;
    }

    this.years = [];
    for (var i = 0; i < 5; i++) {
      this.years.push(this.year - i);
    }

    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }

    this.daysInmonth = new Date(parseInt(year_db.toString(), 10), parseInt(this.month.toString(), 10), 0).getDate();
    this.daysInmonth = parseInt(this.daysInmonth.toString(), 10);
    this.days = [];
    for (var i = 0; i <= this.daysInmonth - 1; i++) {
      this.days.push(i + 1);
    }

    this.ShowYear = true;
    this.ShowMonth = true;
    this.ShowDay = false;
    //this.refreshData();

    if (sessionStorage.getItem('municipality') != undefined) {
      this.database = JSON.parse(sessionStorage.getItem('municipality')).municipality_id + '_fee'
    }

    if (sessionStorage.getItem('token') != undefined) {
      this.token = sessionStorage.getItem('token');
    }

    if (localStorage.getItem('month') != null) {
      if (localStorage.getItem('month').length > 1) {
        this.month = parseInt((localStorage.getItem('month')).match(/"([^']+)"/)[1]);
      }
      else {
        this.month = parseInt(localStorage.getItem('month'));
      }
    }
    if (localStorage.getItem('day') != null) {
      const num = +JSON.parse(localStorage.getItem('day'))
      this.day = num
    }

    if (localStorage.getItem('type') != null) {
      const num = +JSON.parse(localStorage.getItem('type'))
      this.type = num == 1 ? 2 : num == 2 ? 1 : num == 4 ? 4 : num == 5 ? 5 : 3
    }
    const date_f = JSON.parse(localStorage.getItem('datefilter'))

    if (this.type == 4 && date_f != undefined) {
      this.ShowYear = false;
      this.ShowMonth = false;
      this.ShowDay = false;
      this.date.end_date = date_f.end_date;
      this.date.start_date = date_f.start_date;
    }

    this.typeChange();
    this.ShowInvoice = false;
    this.ShowInformation = false;
    this.isLoading = false;
    this.ShowTable = true;
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      language: {
        emptyTable: 'NO Records',
        zeroRecords: '',
      },
      ajax: (dataTablesParameters: any, callback) => {
        console.log('reports-new/get_reports_all_bill_to_datatable')
        that.http
          .post<DataTablesResponse>(
            url + 'reports-new/get_reports_all_bill_to_datatable',
            dataTablesParameters, {
            headers: new HttpHeaders({
              'Content-Type': 'application/json; charset=utf-8',
              'x-access-token': this.token,
              'database': this.database,
              'report_type': this.type.toString(),
              'day': (this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString(),
              'month': (this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString(),
              'year': (this.year - 543).toString(),
              'type': (this.type).toString(),
              'cancel': 'false',
              'date_filter': JSON.stringify(this.date)

            })
          }
          ).subscribe(resp => {
            //debugger
            const uniqueNumbers = resp.data.map(e => e.bill_id).filter((value, index, self) => self.indexOf(value) === index)
            const qw = uniqueNumbers.map(bill_id => {
              return resp.data.filter(q => q.bill_id === bill_id)[0]
            })
            console.log(resp);
            that.reports = qw.map((item) => {

              var formatter = new Intl.NumberFormat('th-TH', {
                style: 'currency',
                currency: 'THB',
              });

              var numberformat = new Intl.NumberFormat('en-IN', {
                maximumSignificantDigits: 3
              });

              this.inform_count = resp.recordsTotal.toString();
              this.inform_price = resp.TotalPrice;
              this.inform_price_value = formatter.format(this.inform_price) + ' บาท';
              return item;
            });
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [{ data: 'bm.bill_id' }, { data: 'cm.customer_id' }, { data: 'cm.customer_name' }, { data: 'fm.place_id' }, { data: 'cp.place_address' },
      { data: 'fy.fee_type_description' }, { data: 'fy.fee_type_unit' }, { data: '' }]
    };


    this.route.queryParams.subscribe(params => {
      this.lang = params['lang'];
      if (this.lang != 'EN' && this.lang != 'TH') {
        this.lang = localStorage.getItem('lang') == 'EN' ? 'EN' : 'TH';
        this.language = report_bill_lang[this.lang];
      } else {
        this.language = report_bill_lang[this.lang];
        localStorage.setItem('lang', this.lang);
      }
    });
  }


  refreshData() {
    if (this.type != 4) {
      localStorage.removeItem('datefilter');
    }
    if (this.type == 4) {
      if ((!this.date.start_date || !this.date.end_date )|| moment(this.date.start_date).format("YYYY-MM-DD") > moment(this.date.end_date).format("YYYY-MM-DD")) {
        return Swal.fire({
          text: 'ใส่ข้อมูลไม่ถูกต้อง',
          type: 'warning',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000
        }).then((result) => {
        })
      }
      if ((!this.date.start_date || !this.date.end_date )|| moment(this.date.end_date).format("YYYY-MM-DD") < moment(this.date.start_date).format("YYYY-MM-DD")) {
        return Swal.fire({
          text: 'ใส่ข้อมูลไม่ถูกต้อง',
          type: 'warning',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000
        }).then((result) => {
        })
      }

    }

    this.inform_count = "0";
    this.inform_price_value = "0.0";
    this.ShowTable = false;
    this.isLoading = true;
    this.ShowInvoice = false;
    this.ShowInformation = false;

    setTimeout(() => {
      this.ShowTable = true;
      this.isLoading = false;
    }, 100);
  }


  typeChange() {
    if (this.type == 4 || this.type == 5) {
      this.ShowDay = false;
    }
    switch (this.type.toString()) {
      case '1':
        this.ShowYear = true;
        this.ShowMonth = true;
        this.ShowDay = true;
        break;
      case '2':
        this.ShowYear = true;
        this.ShowMonth = true;
        this.ShowDay = false;
        break;
      case '3':
        this.ShowYear = true;
        this.ShowMonth = false;
        this.ShowDay = false;
        break;
      case '99':
      case '98':
      case '97':
        this.ShowYear = false;
        this.ShowMonth = false;
        this.ShowDay = false;
        break;
    }
  }

  monthChange() {
    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }

    this.daysInmonth = new Date(parseInt(year_db.toString(), 10), parseInt(this.month.toString(), 10), 0).getDate();
    this.daysInmonth = parseInt(this.daysInmonth.toString(), 10);
    this.days = [];
    for (var i = 0; i <= this.daysInmonth - 1; i++) {
      this.days.push(i + 1);
    }
  }

  show_information(item) {
    console.log(item);
    this.ShowInformation = true;
    this.ShowInvoice = false;
    this.ShowTable = false;
    this.report.customer_id = item.customer_id;
    this.report.customer_name = item.customer_name;
    this.report.place_id = item.place_id;
    this.report.place_address = item.place_address;
    this.report.place_type_description = item.place_type_description;
    this.report.fee_type_description = item.fee_type_description;
    this.report.fee_type_unit = item.fee_count + ' ' + item.fee_type_unit;

    this.report_invoice = { bill_id: "", user_id: "", create_datetime: "", discount: "", total_price: "", fee_description: "", payment_description: "" };
    this.isLoading = true;
    this.search_report = "";

    this.service.postData({ bill_id: item.bill_id }, "reports-new/get_reports_bill").then((result: any) => {
      console.log(result);
      this.all_reports_invoice = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""));
      this.reports_invoices = this.all_reports_invoice.filter((item) => {
        var res: any;
        res = item;

        var xy = 0;
        xy = parseInt(moment(item.create_datetime).format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        res.create_datetime = moment(item.create_datetime).format("DD/MM/") + xy;

        xy = 0;
        xy = parseInt(moment(item.due_date).format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        res.due_date = moment(item.due_date).format("DD/MM/") + xy;
        res.status_code = item.payment_description;
        return res;
      });
      this.all_reports_invoice = this.reports_invoices
      this.isLoading = false;
    }, (err) => {
      this.isLoading = false;
      Swal.fire({
        title: this.language.no_internet_alert,
        text: '',
        type: 'error',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      });
    })
  }

  back() {
    this.ShowInformation = false;
    this.ShowTable = true;
    this.report = { customer_name: "", place_id: "", place_address: "", place_type_description: "", fee_type_description: "", fee_type_unit: "", request_general_id: "", customer_id: "" };
  }

  onSearch_invoice(event) {
    this.reports_invoices = this.all_reports_invoice.filter((item) => {
      return compare(item.invoice_id) || compare(item.fee_description) || compare(item.create_datetime) || compare(item.due_date) || compare(item.total_price) || compare(item.status_code) || compare(item.user_id);
    })
    function compare(type) {
      if (type != undefined) {
        return type.toString().toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
      }
      else {
        return [];
      }

    }
  }

  onSearch_place(event) {
    this.reports = this.all_reports.filter((item) => {
      return compare(item.place_id) || compare(item.place_address) || compare(item.place_type_description) || compare(item.fee_type_description) || compare(item.fee_type_unit) || compare(item.customer_id) || compare(item.customer_name);
    })
    function compare(type) {
      if (type != undefined) {
        return type.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
      }
      else {
        return [];
      }

    }
  }

  print_invoice(item) {
    localStorage.removeItem("type");

    console.log(item);
    const municipality_id = this.service.getDatabase().substring(0, 5);
    const bill_id = item[0].bill_id;
    // this.service.postData({ bill_id }, "invoice/print-bill").then((result) => {
    window.open(report_url + "print-bill?bill_id=" + bill_id + "&municipality_id=" + municipality_id, "_blank");
    // })
  }
  print_invoice_3x4(item) {
    localStorage.removeItem("type");

    const municipality_id = this.service.getDatabase().substring(0, 5);
    const bill_id = item[0].bill_id;
    // this.service.postData({ bill_id }, "invoice/print-bill").then((result) => {
    window.open(report_url + "print-bill-3x4?bill_id=" + bill_id + "&municipality_id=" + municipality_id, "_blank");
    // })
  }
  download_excel() {
    localStorage.removeItem("type");

    const municipality_id = this.service.getDatabase().substring(0, 5);
    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }

    switch (this.type.toString()) {
      case '1':
        var dateString = ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + '-' + ((this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString()) + '-' + (year_db.toString());
        var momentObj = moment(dateString, 'MM-DD-YYYY');
        window.open(report_url + "print-report-bill-excel?datetime=" + momentObj.format('X') + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '2':
        window.open(report_url + "print-report-bill-excel?month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '3':
        window.open(report_url + "print-report-bill-excel?year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '4':
        window.open(report_url + "print-report-bill-excel?year=" + (year_db.toString()) + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '5':
        window.open(report_url + "print-report-bill-excel?year=" + (year_db.toString()) + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
    }

  }
  print_report() {
    localStorage.removeItem("type");

    const municipality_id = this.service.getDatabase().substring(0, 5);
    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }

    switch (this.type.toString()) {
      case '1':
        var dateString = ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + '-' + ((this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString()) + '-' + (year_db.toString());
        var momentObj = moment(dateString, 'MM-DD-YYYY');
        window.open(report_url + "print-report-bill?datetime=" + momentObj.format('X') + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '2':
        window.open(report_url + "print-report-bill?month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '3':
        window.open(report_url + "print-report-bill?year=" + (year_db.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '4':
        window.open(report_url + "print-report-bill?year=" + (year_db.toString()) + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
      case '5':
        window.open(report_url + "print-report-bill?year=" + (year_db.toString()) + "&month=" + ((this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()) + "&report=" + this.type.toString() + "&municipality_id=" + municipality_id + "&date_filter=" + (JSON.stringify(this.date)), "_blank");
        break;
    }

  }

  show_bill(item) {
    this.ShowInvoice = true;
    this.service.postData({ customer_id: this.report.customer_id }, "request-general/get").then((result: any) => {
      this.request_general = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""))
      this.service.postData({ invoice_id: item.invoice_id, topic: 'bill' }, "invoice/get-invoice-detail").then((result2: any) => {
        this.invoices = JSON.parse(JSON.stringify(result2.data).replace(/\:null/gi, "\:\"\""));
        if (result2.data.length > 0) {
          this.disableSelect = false
        }
        else {
          this.disableSelect = true
        }
        this.invoices = this.invoices.filter((item) => {
          var res: any;
          res = item;

          var xy = 0;
          xy = parseInt(moment(item.create_datetime).format('YYYY'));

          if (xy < 2500) {
            xy = xy + 543;
          }

          res.create_datetime = moment(item.create_datetime).format("DD/MM/") + xy;

          xy = 0;
          xy = parseInt(moment(item.due_date).format('YYYY'));

          if (xy < 2500) {
            xy = xy + 543;
          }

          res.due_date = moment(item.due_date).format("DD/MM/") + xy;
          res.status_code = (item.status_code == '02' ? 'ชำระแล้ว' : 'ยังไม่ชำระ')
          return res;
        });

        this.isLoading = false;
      })
    })
  }

  delete() {
    if (this.invoices.length > 0) {
      this.submitted = true;
      if (this.request_general_id != '' && this.request_general_id != undefined) {
        Swal.fire({
          title: this.language.confirm_delete,
          text: this.language.warining_delete,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.language.want_delete,
          cancelButtonText: this.language.close
        }).then((result) => {
          if (result.value) {
            this.service.postData({ fee_id: this.invoices[0].fee_id, bill_id: this.invoices[0].bill_id, request_general_id: this.request_general_id }, "invoice/cancel-bill").then(result => {
              this.isLoading = false;
              Swal.fire({
                title: this.language.deleted,
                text: '',
                type: 'success',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 2000
              }).then((result) => {
                this.refreshData();
              })
            }, err => {
              window.location.href = this.service.start_host
              this.isLoading = false;
            })
          }
        });
      }
    }

  }

}
